module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0121.jpg?v=09ea3b07";